/**
 * Storage identity for offline writes.
 *
 * Queue data is intentionally namespaced by the authenticated user so a
 * subsequent account on the same browser cannot flush another user's changes.
 */
export const SYNC_QUEUE_KEY = 'fintrack:syncQueue';

export const getSyncQueueStorageKey = (userId: string): string => {
  if (userId.length === 0) {
    throw new Error('An authenticated user ID is required for offline sync.');
  }
  return `${SYNC_QUEUE_KEY}:${encodeURIComponent(userId)}`;
};
